class MATACheckFilters {
  constructor( i, e ) {
      this.$index = i;
      this.$element = $( e );


      this.selectors = {
        optionCheckbox: ".filter-group__options-option input[type='checkbox']"
      }

      this.init();
  }

  init() {
    this.$optionCheckbox = this.$element.find( this.selectors.optionCheckbox );
    this.__checkIfMixedSets();
  }

  __checkIfMixedSets() {

    //run only if this is on the page /collections/shop-all
    // console.info(document.URL);
    if (document.URL.includes('collections/shop-all')) {
      this.$optionCheckbox.each((i, e) => {
        // console.log(e);
        if(e.value == 'gid://shopify/Metaobject/37392384280' && e.checked) {
          document.title = "Mix Sets"
        } else {
          return
        }
      })
    }
  }
}